import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { styles } from "../styles/publicStyles";
import EmptySection, { companyName } from "./EmptySection";

const FaqSection = ({ faqs, company }) => {
  const theme = useTheme();

  // No questions yet: the heading and the same empty-state card as the
  // other tabs, instead of an empty box.
  if (!faqs || faqs.length === 0) {
    return (
      <Box id="faq">
        <EmptySection
          icon={HelpOutlineIcon}
          title="No questions answered yet"
          message={`${companyName(company)} has not added answers to common security questions yet.`}
          company={company}
          askText="To ask a question"
        />
      </Box>
    );
  }

  return (
    <Card id="faq" sx={styles.mainCard}>
      <Box sx={{ p: 2 }}>
        {faqs.map((faq) => (
          <Accordion
            key={faq.id}
            disableGutters
            elevation={0}
            sx={{
              border: `1px solid ${theme.customColors.border.main}`,
              borderRadius: "8px !important",
              mb: 1,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 500 }}>{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
              <Typography
                variant="body2"
                sx={{
                  color: theme.customColors.text.secondary,
                  lineHeight: 1.7,
                }}
              >
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Card>
  );
};

export default FaqSection;
